import React from "react";

import styles from "./modulecontent.module.scss";

interface IProps {}

const ModuleContent: React.FC<IProps> = (props) => {
  return (
    <div className={styles.moduleContent}>
      {props.children}
    </div>
  ) 
};

export default ModuleContent;